import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuoteDocumentInput = () => {
  const { documentId = '' } = useParams();
  const decodedId = documentId ? atob(documentId) : documentId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quoteDocument';

  useEffect(() => {
    if (documentId) { setIsEditing(true); fetchDetails(); }
  }, [documentId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['quoteDocument'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Quote Document details:', error); }
  };

  const fields = [
    { name: "quote", label: "Quote", type: "number", required: true },
    { name: "document", label: "Document", type: "file", required: !isEditing }
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Document' : 'Create Quote Document'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuoteDocumentInput;